import React from "react";
import {MOVIES} from 'api';
import { RESET,
         SET_MOVIES, 
         SET_SEARCH_MOVIES, 
         SET_CATEGORIES, 
         SET_CURRENT_MOVIE,
         SET_CURRENT_SERIE,
         SET_CURRENT_TRAILER,
         SET_SERIES
} from 'constants/store';

type State = {
    movies: Array<any>
    series: Array<any>
    tv: Array<any>
    search_movies: Array<any>
    categories: Array<any>
    trailer: string
};


type Actions = 
  {type: "reset"} |
  {type: 'setMovies', movies: Array<any>}  |
  {type: 'setSeries', series: Array<any>}  |
  {type: 'setSearchMovies', search_movies: Array<any>} |
  {type: 'setCategories', categories: Array<any>} |
  {type: 'setCurrentMovie', movie: Object} |
  {type: 'setCurrentTrailer', movie: Object} |
  {type: 'setCurrentSerie', serie: Object}

  
let reducer = (state: State, action: Actions) => {
  switch (action.type) {
    case RESET:
      return initialState;
    case SET_MOVIES:
      return { ...state, movies: action.movies };
   case SET_SERIES:
      return { ...state, series: action.series };
    case SET_SEARCH_MOVIES:
      return { ...state, search_movies: action.search_movies };
   case SET_CATEGORIES:
      return { ...state, categories: action.categories };
    case SET_CURRENT_MOVIE:
      return { ...state, movie: action.movie };
    case SET_CURRENT_SERIE:
      return { ...state, serie: action.serie };
    case SET_CURRENT_TRAILER:
      return { ...state, trailer: action.trailer };
    default:
      return state;
  }
};


let Context = React.createContext<any>(null);

let initialState = {
  movies: [],
  series: [],
  search_movies: MOVIES,
  categories: [],
  movie: {},
  serie: {},
  trailer: ''
};

type ContextProps = {
  children: any
};

const  ContextProvider: React.FC<ContextProps> = (props) : JSX.Element => {
  let [state, dispatch] = React.useReducer(reducer, initialState);
  let value = { state, dispatch };
   
  return (
    <Context.Provider value={value}>
      {props.children}
    </Context.Provider>
  );
};

const  useStore = () : any => {
  return (
    React.useContext(Context)
  )
};

export { useStore, ContextProvider };